import Ajax from './Ajax.js'

// Sales simulator (administrators only), see new-server/src/utils/sales-simulator.js
const Simulator = {
  // tree types and growth formulas, fertilizing factors, platform densities, default prices
  getModel: () => Ajax.get('/simulator/model'),
  // without source: the sources that cover the point; with source: what that source knows there
  detectSources: (lat, lng) => Ajax.get(`/simulator/detect?lat=${lat}&lng=${lng}`),
  detect: (lat, lng, source) => Ajax.get(`/simulator/detect?lat=${lat}&lng=${lng}&source=${encodeURIComponent(source)}`),
  // the Forest Centre stands of a whole area (a property larger than the window around the point)
  detectArea: (lat, lng, source, bbox) => Ajax.get(`/simulator/detect?lat=${lat}&lng=${lng}&source=${encodeURIComponent(source)}&bbox=${bbox.map((v) => v.toFixed(6)).join(',')}`),
  saveDefaults: (values) => Ajax.put('/simulator/defaults', values),
  list: () => Ajax.get('/simulator/simulations'),
  get: (id) => Ajax.get(`/simulator/simulations/${id}`),
  create: (simulation) => Ajax.post('/simulator/simulations', simulation),
  update: (id, simulation) => Ajax.put(`/simulator/simulations/${id}`, simulation),
  setStatus: (id, status) => Ajax.put(`/simulator/simulations/${id}/status`, { status }),
  remove: (id) => Ajax.delete(`/simulator/simulations/${id}`),
}

export default Simulator
